import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api";

const DynamicHomeTestimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState({}); // track expanded state per testimonial

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await api.get(
          `${process.env.REACT_APP_API_URL}/api/testimonials`
        );
        setTestimonials(response.data);
      } catch (err) {
        setError(
          err.response?.data?.message || err.message || "Something went wrong"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const toggleExpand = (index) => {
    setExpanded((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const truncateText = (text, index) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= 25) return text;

    if (expanded[index]) {
      return text;
    }

    return words.slice(0, 25).join(" ") + "...";
  };

  const settings = {
    dots: false,
    infinite: testimonials.length > 1,
    speed: 500,
    slidesToShow: testimonials.length >= 3 ? 3 : testimonials.length,
    slidesToScroll: 1,
    autoplay: testimonials.length > 1,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: testimonials.length >= 2 ? 2 : testimonials.length,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  if (loading) return <></>;
  if (error) return <></>;
  if (testimonials.length === 0) return <></>;

  return (
    <section
      className="high-school-study-educamb-area"
      style={{ padding: "0 0 40px 0px" }}
    >
      <div className="container">
        <div className="sec-title text-center">
          <h2 style={{ color: "#004a8e" }}>
            Journey with Chettinad - Experience Sharing
          </h2>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="theme_carousel slick-theme home-testimonial">
              <Slider {...settings}>
                {testimonials.map((testimonial, index) => (
                  <div
                    className="single-high-school-study-educamb-box"
                    key={index}
                  >
                    <div className="img-box" style={{ borderTop: "none" }}>
                      <div className="inner">
                        <p className="mb-0">{truncateText(testimonial.text, index)}</p>

                        {/* ✅ View More / Less Button */}
                        {testimonial.text.trim().split(/\s+/).length > 25 && (
                          <a
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "#004a8e",
                              padding: 0,
                            }}
                            onClick={() => toggleExpand(index)}
                          >
                            {expanded[index] ? "View Less" : "View More"}
                          </a>
                        )}

                        <div className="rating-icon">
                          {[...Array(5)].map((_, i) => (
                            <i
                              key={i}
                              className={`fa ${i < testimonial.stars ? "fa-star" : "fa-star-o"}`}
                              style={{ color: "#FFD700" }}
                            ></i>
                          ))}
                        </div>

                      </div>
                      <div className="author-info">
                        <div className="thumb">
                          <img
                            src={`${process.env.REACT_APP_API_URL}/public${testimonial.image_path}`}
                            alt={testimonial.name}
                            style={{
                              width: "50px",
                              height: "50px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div className="info">
                          <h5 style={{ marginBottom: 0 }}>
                            {testimonial.name}
                          </h5>
                          <span className="subtitle">{testimonial.role}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DynamicHomeTestimonial;